import { FC } from 'react'
import styled from 'styled-components'
import { Flex } from '@/components/atoms/Grid'
import { validFor } from '@/theme/validFor'
import { contactServiceData, ContactServiceOption } from './contactServiceData'
import ContactServiceBox from './contactServiceBox'
import { useAsset } from '@/providers/assetsProvider'

const RootWrapper = styled(Flex)`
  width: 100%;
  margin-top: 20px;
  justify-content: center;
  align-items: center;
  position: relative;

  ${validFor.mobile`
    flex-direction: column !important;
    align-items: center !important;
    justify-content: flex-start;
    position: static;
  `};

  ${validFor.tablet`
    flex-direction: column !important;
    align-items: center !important;
    justify-content: flex-start;
    position: static;
  `};
`

const LeftWrapper = styled(Flex)`
  gap: 20px;
  justify-content: center;

  ${validFor.mobile`
    width: 100%;
    flex-direction: column;
    align-items: center;
  `};
`

const RightWrapper = styled(Flex)`
  position: absolute;
  right: clamp(10px, 5vw, 75px);
  align-items: center;
  justify-content: center;

  ${validFor.tablet`
    position: static;
    margin-top: 20px;
    width: 100%;
    align-items: center;
    justify-content: center;
  `};

  ${validFor.mobile`
    position: static;
    margin-top: 20px;
    width: 100%;
    align-items: center;
    justify-content: center;
  `};
`

const ContactService: FC = () => {
  const { showHeureka, hidePhoneContact } = useAsset()
  return (
    <RootWrapper>
      <LeftWrapper>
        {contactServiceData
          .filter(
            (service) =>
              !hidePhoneContact || service.id !== ContactServiceOption.Phone
          )
          .map((service) => (
            <ContactServiceBox key={service.id} service={service} />
          ))}
      </LeftWrapper>

      {showHeureka && (
        <RightWrapper>
          <img
            src="https://im9.cz/cb/10970-4.svg"
            alt="Heureka ověřeno zákazníky"
            style={{ maxWidth: '100%', margin: '0 auto' }}
          />
        </RightWrapper>
      )}
    </RootWrapper>
  )
}

export default ContactService
